// src/components/EquipoViewerDialog.jsx
// Vista de un resultado "equipo" del buscador global — sin navegar.
// Embebe BusquedaUnidadTab (la misma tabla multi-plataforma de /vehiculos:
// YPFB internacional/nacional, flespi, SORT...) con la búsqueda ya disparada.
// Criterio: busca por placa si la tiene; si no, cae a num_sim o emai — mismo
// orden que ya prioriza `item.titulo` en busquedaGlobalModel.js (backend).
import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusquedaUnidadTab from "../modules/vehiculos/components/BusquedaUnidadTab";

export default function EquipoViewerDialog({ open, onClose, equipo }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth PaperProps={{ sx: { height: "90vh" } }}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "1rem", fontWeight: 800 }}>
        {equipo?.titulo || "Equipo"}
        <IconButton size="small" onClick={onClose} aria-label="Cerrar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 1.5 }}>
        {equipo && <BusquedaUnidadTab key={equipo.titulo} valorInicial={equipo.titulo} />}
      </DialogContent>
    </Dialog>
  );
}
